import masterDataSlice from './master-data-reducer'

export {
  fetchMasterData,
  selectHasError,
  selectHasReceivedMasterData,
  selectMasterData,
  selectProducts
} from './master-data-reducer'

export default masterDataSlice
